import React, { Component } from 'react';
import styled from 'styled-components';

import WP from 'WP';

import EventCard from './EventCard';
import Container from 'partials/Container';
import GridElement from 'partials/GridElement';

import Media from 'css/Media';

export class RelatedEvents extends Component {

    render() {
        const { links } = this.props;
        
        return (
            <Wrapper>
                <Container grid>
                    <GridElement
                        colStart={{default: 1, s: 3}}
                        colEnd={{default: 8, s: 12}}
                        rowStart={1}
                        rowEnd={2}
                    >
                    <h3>{WP.trans.moreEvents}</h3>
                    </GridElement>
                    <StyledGridElement
                        colStart={{default: 1, s: 3}}
                        colEnd={{default: 8, s: 12}}
                        rowStart={{default: 2, s: 2}}
                        rowEnd={{default: 4, s: 3}}
                    >
                        <EventCard event={links[0]} />
                    </StyledGridElement>
                    <StyledGridElement
                        colStart={{default: 1, s: 13}}
                        colEnd={{default: 8, s: 22}}
                        rowStart={{default: 4, s: 2}}
                        rowEnd={{default: 7, s: 3}}
                    >
                        <EventCard event={links[1]} />
                    </StyledGridElement>
                </Container>
            </Wrapper>
        )
    }
}

export default RelatedEvents;

const Wrapper = styled.section`
    user-select: none;
    padding-bottom: ${props => props.theme.spacing.blockL};

    .container {
        ${Media.lessThan('s')`
            grid-template-rows: (7, auto);
        `}

        h3 {
            margin-bottom: ${props => props.theme.spacing.contentL};
        }
    }
`

const StyledGridElement = styled(GridElement)`
    padding-bottom: ${props => props.theme.spacing.elementS};

    ${Media.greaterThan('s')`
        padding-bottom: 0;
    `}

    span {
        font-size: 22px;
        font-family: 'Untitled';
        line-height: 34px;
    }
`